<template>
  <div
    class="border border-secondary rounded mb-4"
    :class="{ 'border-secondary': isVisible }"
  >
    <!--    <b-card-header-->
    <!--      header-text-variant="secondary"-->
    <!--      header-class="vue-json-query-builder-header d-flex align-items-center"-->
    <!--      @click="isVisible = !isVisible"-->
    <!--    >-->
    <!--      &lt;!&ndash;      <small class="mr-auto">Action Builder</small>&ndash;&gt;-->
    <!--      <div></div>-->

    <!--      <b-icon-caret-down-fill v-if="isVisible" />-->
    <!--      <b-icon-caret-up-fill v-else />-->
    <!--    </b-card-header>-->
    <div class="w-100 p-0" v-if="isVisible">
      <ActionGroup
        :selectedReportNotificationType="selectedReportNotificationType"
        :current-query="query"
        :filter="filter"
        ref="actionGroup"
      />
    </div>
  </div>
</template>

<script>
import ActionGroup from "@/own/components/settings/notifications/highValueShipmentBuilder/ActionGroup.vue";
export default {
  name: "HighValueShipmentBuilder",
  components: {
    ActionGroup,
  },
  props: {
    filter: {
      type: Object,
      required: true,
    },
    selectedReportNotificationType: {
      type: String,
      required: true,
    },
  },
  mounted() {
    if (this.filterAllData[`${this.selectedReportNotificationType}`]) {
      this.filterAllData[`${this.selectedReportNotificationType}`].forEach(
        (item) => {
          this.query.push({
            filterData: item.value,
            threshold: item.threshold,
          });
        }
      );
    }
    if (this.filter?.values) this.countries = this.filter.values;
  },
  computed: {
    filterAllData() {
      return this.$store.getters.getFiltersData;
    },
  },
  data: function () {
    return {
      isVisible: true,
      query: [],
      countries: [],
    };
  },
};
</script>

<style lang="scss" scoped>
.vue-json-query-builder {
  font-size: 12px;
  user-select: none;
  * {
    font-size: 15px !important;
  }
  .vue-json-query-builder-header {
    cursor: pointer;
  }
}
</style>
